import AnnouncementFormPage from './pages/dashboard/announcement-form';
import AnnouncementPage from './pages/dashboard/announcement';
import OnboardingSettings from './pages/onboarding/OnboardingSettings';import AccountSetup from './pages/onboarding/AccountSetup';import OnboardingDetail from './pages/onboarding/OnboardingDetail';import OnboardingHrFinanceTasks from './pages/onboarding/OnboardingHrFinanceTasks';import MyOnboardingPortal from './pages/onboarding/MyOnboardingPortal';import OnboardingTemplateEdit from './pages/onboarding/OnboardingTemplateEdit';import NewStarterForm from './pages/onboarding/NewStarterForm';import OnboardingFormPage from './pages/onboarding/forms/OnboardingFormPage';                {/* Onboarding routes */}
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Layout } from "./components/Layout";
import { AuthProvider } from "./context/AuthContext";
import { DataProvider } from "./context/DataContext";
import { NotificationProvider } from "./context/NotificationContext";
import { Toaster } from "sonner";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AttendanceRoute } from "./components/AttendanceRoute";

// Onboarding
import OnboardingDashboard from './pages/onboarding/OnboardingDashboard';
import OnboardingTemplates from './pages/onboarding/OnboardingTemplates';
import CommenceHiring from './pages/onboarding/CommenceHiring';

// Auth pages
import LoginPage from './pages/Login';
import SignUpPage from './pages/SignUp';
import ChangePasswordPage from './pages/changepassword';
import ResetPasswordPage from './pages/ResetPassword';

// Main pages
import DashboardPage from './pages/dashboard/dashboard';
import HRDashboardPage from './pages/hr/HRDashboardPage';
import SettingsPage from './pages/settings';
import OrganizationPage from './pages/organization';
import AttendanceDashboard from './pages/attendance/AttendanceDashboard';
import RequestLeave from './pages/attendance/RequestLeave';
import LeaveCalendar from './pages/attendance/LeaveCalendar';
import AttendanceHistory from './pages/attendance/AttendanceHistory';
import ApproveRequests from './pages/attendance/ApproveRequests';
import ReportAbsence from './pages/attendance/ReportAbsence';
import LeaveAdmin from './pages/attendance/LeaveAdmin';
import LeaveDigest from './pages/attendance/LeaveDigest';
import AdjustLeaveBalance from './pages/attendance/AdjustLeaveBalance';
import AttendanceSettings from './pages/attendance/AttendanceSettings';


// Departments
import DepartmentsPage from './pages/departments';
import DepartmentPage from './pages/departmentpage';

// People
import PeoplePage from './pages/people';
import PersonPage from './pages/personpage';
import AddPersonPage from './pages/add-person';
import EditPersonPage from './pages/edit-person';
import PeopleSettingsPage from './pages/people-settings';
import ArchivePersonPage from './pages/person-archive/ArchivePersonPage';
import AddQualificationPage from './pages/qualifications/AddQualificationPage';
import EditQualificationPage from './pages/qualifications/EditQualificationPage';
import RecycleBinPage from './pages/qualifications/RecycleBinPage';
import QualificationSettingsPage from './pages/qualifications/QualificationSettingsPage';
import QualificationRegisterPage from './pages/qualifications/QualificationRegisterPage';
// Learning (LEARNING.md) — HR module: catalogue, register, categories, learner surface.
import CourseLibraryPage from './pages/learning/CourseLibraryPage';
import CourseFormPage from './pages/learning/CourseFormPage';
import CourseCategoriesPage from './pages/learning/CourseCategoriesPage';
import LearningRegisterPage from './pages/learning/LearningRegisterPage';
import AssignmentDetailPage from './pages/learning/AssignmentDetailPage';
import MyLearningPage from './pages/learning/MyLearningPage';
import CourseIntroPage from './pages/learning/CourseIntroPage';
import CoursePlayerPage from './pages/learning/CoursePlayerPage';
import LearningBriefPage from './pages/learning/LearningBriefPage';
import LearningSettingsPage from './pages/learning/LearningSettingsPage';
import MyPerformancePage from './pages/performance/MyPerformancePage';
import PerformanceSettingsPage from './pages/performance/PerformanceSettingsPage';

// New Procedures (redesigned)
import NewProceduresListPage from './pages/procedure-v2/ProceduresList';
import NewProcedurePage from './pages/procedure-v2/ProcedureDetail';

// Procedures (legacy)
import ProceduresPage from './pages/procedures';
import ProcedurePage from './pages/procedurepage';
import ProcedureFormPage from './pages/procedure-form';

// Training - removed, now using Training Plans

// Activities
import ActivitiesPage from './pages/activities';
import ActivityPage from './pages/activitypage';

// Job Roles
import JobRolesPage from './pages/jobroles';
import JobRolePage from './pages/jobrolepage';
import EditJobRolePage from './pages/EditJobRolePage';
import AddJobRolePage from './pages/AddJobRolePage';
import JobRoleSettings from './pages/JobRoleSettings';
import JobPositionFormPage from './pages/JobPositionFormPage';

// Training Plans
import TrainingPlansPage from './pages/training-plans';
import TrainingPlansPageDetail from './pages/training-planspage';
import TrainingPlanSettings from './pages/TrainingPlanSettings';
import TrainingPlanForm from './pages/TrainingPlanForm';

// Recruitment
import RecruitmentDashboard from './pages/recruitment/RecruitmentDashboard';
import NewRecruitmentRequest from './pages/recruitment/NewRecruitmentRequest';
import EditRecruitmentRequest from './pages/recruitment/EditRecruitmentRequest';
import RecruitmentSettings from './pages/recruitment/RecruitmentSettings';
import NewOfferTemplate from './pages/recruitment/NewOfferTemplate';
import EditOfferTemplate from './pages/recruitment/EditOfferTemplate';
import CreateOffer from './pages/recruitment/CreateOffer';
import OfferDetail from './pages/recruitment/OfferDetail';
import RequisitionDetail from './pages/recruitment/RequisitionDetail';
import AddCandidate from './pages/recruitment/AddCandidate';
import CandidateDetail from './pages/recruitment/CandidateDetail';
import EditCandidate from './pages/recruitment/EditCandidate';
import InterviewTemplates from './pages/recruitment/InterviewTemplates';
import CreateInterviewTemplate from './pages/recruitment/CreateInterviewTemplate';
import ValuesManagement from './pages/recruitment/ValuesManagement';

// Help
import HelpPage from './pages/help';

// Policies
import PoliciesPage from './pages/policies';
import PolicyDetailPage from './pages/policy-detail';
import PolicyNewPage from './pages/policy-new';
import PolicyAssignPage from './pages/policy-assign';
import PolicyNewAssignPage from './pages/policy-new-assign';
import PolicyViewPage from './pages/policy-view';
import MyPoliciesPage from './pages/my-policies';
import PolicyEditPage from './pages/policy-edit';

// Memos
import MemoNewPage from './pages/memo-new';
import MemoAssignPage from './pages/memo-assign';

// Development
import DevelopmentPage from './pages/development';
import DevelopmentPersonPage from './pages/development_person';
import DelegationSettingsPage from './pages/delegation_settings';
import MemoViewPage from './pages/memo-view';
import MemoEditPage from './pages/memo-edit';
import MemoSignPage from './pages/memo-sign';
import MemoNewAssignPage from './pages/memo-new-assign';

// Inventory
import CustomersPage from './pages/lists/CustomersPage';
import VendorsPage from './pages/lists/VendorsPage';
import BranchesPage from './pages/lists/BranchesPage';
import ProjectsPage from './pages/lists/ProjectsPage';
import YardsPage from './pages/stock/YardsPage';
import YardFormPage from './pages/stock/YardFormPage';
import ProductLibraryPage from './pages/stock/ProductLibraryPage';
import ReturnOrdersPage from './pages/stock/ReturnOrdersPage';
import ReturnOrderDetailPage from './pages/stock/ReturnOrderDetailPage';
import ReturnOrderFormPage from './pages/stock/ReturnOrderFormPage';
import ClosedYardsPage from './pages/stock/ClosedYardsPage';
import ImportOrdersPage from './pages/stock/ImportOrdersPage';
import ImportOrderFormPage from './pages/stock/ImportOrderFormPage';
import ImportOrderDetailPage from './pages/stock/ImportOrderDetailPage';
import TransferOrdersPage from './pages/stock/TransferOrdersPage';
import TransferOrderDetailPage from './pages/stock/TransferOrderDetailPage';
import StockDashboardPage from './pages/stock/StockDashboardPage';
import DeliveryOrdersPage from './pages/stock/DeliveryOrdersPage';
import DeliveryOrderDetailPage from './pages/stock/DeliveryOrderDetailPage';
import DeliveryOrderFormPage from './pages/stock/DeliveryOrderFormPage';
import PickSheetPage from './pages/stock/PickSheetPage';
import DeliverySettingsPage from './pages/stock/DeliverySettingsPage';
import StockModulePlaceholder from './pages/stock/StockModulePlaceholder';
import ProcurementDashboardPage from './pages/stock/procurement/ProcurementDashboardPage';
import PurchaseOrdersPage from './pages/stock/procurement/PurchaseOrdersPage';
import PurchaseOrderFormPage from './pages/stock/procurement/PurchaseOrderFormPage';
import PurchaseOrderDetailPage from './pages/stock/procurement/PurchaseOrderDetailPage';
import PurchaseOrderApprovalsPage from './pages/stock/procurement/PurchaseOrderApprovalsPage';
import ReceivingQueuePage from './pages/stock/procurement/ReceivingQueuePage';
import ReceiptCapturePage from './pages/stock/procurement/ReceiptCapturePage';
import ProcurementSettingsPage from './pages/stock/procurement/ProcurementSettingsPage';
import InventoryManagement from './pages/inventory/InventoryManagement';
import CreateIssuance from './pages/inventory/CreateIssuance';
import EditIssuance from './pages/inventory/EditIssuance';
import BusinessSystemsManagement from './pages/business-systems/BusinessSystemsManagement';
import CreateBusinessSystem from './pages/business-systems/CreateBusinessSystem';
import BusinessSystemDetails from './pages/business-systems/BusinessSystemDetails';
import EditBusinessSystem from './pages/business-systems/EditBusinessSystem';

// Assets
import AssetDashboard from './pages/assets/AssetDashboard';
import CreateAsset from './pages/assets/CreateAsset';
import AssetDetails from './pages/assets/AssetDetails';
import PrintLabels from './pages/assets/PrintLabels';
import EditAsset from './pages/assets/EditAsset';
import ScheduleMaintenance from './pages/assets/ScheduleMaintenance';
import RecordRepair from './pages/assets/RecordRepair';
import EditRepair from './pages/assets/EditRepair';
import RepairDetails from './pages/assets/RepairDetails';
import MaintenanceDetails from './pages/assets/MaintenanceDetails';
import AssignAssets from './pages/assets/AssignAssets';
import ReturnAsset from './pages/assets/ReturnAsset';
import ReassignAsset from './pages/assets/ReassignAsset';
import AssignmentDetails from './pages/assets/AssignmentDetails';
import AssetSettings from './pages/assets/AssetSettings';
import NewInspection from './pages/assets/NewInspection';
import ViewInspection from './pages/assets/ViewInspection';
import ElectricalInspectionDetails from './pages/assets/ElectricalInspectionDetails';
import NewElectricalInspectionPage from './pages/assets/NewElectricalInspectionPage';
import EditElectricalInspectionPage from './pages/assets/EditElectricalInspectionPage';
import NewLiftingInspectionPage from './pages/assets/NewLiftingInspectionPage';
import LiftingInspectionDetails from './pages/assets/LiftingInspectionDetails';
import EditLiftingInspectionPage from './pages/assets/EditLiftingInspectionPage';
import AddReminderPage from './pages/assets/AddReminderPage';
import EditReminderPage from './pages/assets/EditReminderPage';
import AssetActionItems from './pages/assets/AssetActionItems';

// Finance
import DirectDebitRegisterPage from './pages/finance/DirectDebitRegister';
import DirectDebitCreatePage from './pages/finance/DirectDebitCreate';
import DirectDebitDetailsPage from './pages/finance/DirectDebitDetails';
import DirectDebitEditPage from './pages/finance/DirectDebitEdit';
import FinanceSettingsPage from './pages/finance/FinanceSettings';
import DirectDebitListPage from './pages/finance/DirectDebitList';

// Service Desk
import MyRequests from './pages/service-desk/MyRequests';
import CreateRequest from './pages/service-desk/CreateRequest';
import AdminDashboard from './pages/service-desk/AdminDashboard';
import ServiceDeskSettings from './pages/service-desk/ServiceDeskSettings';
import RequestView from './pages/service-desk/RequestView';
import CreateRequestForm from './pages/service-desk/CreateRequestForm';
import ViewRequestForm from './pages/service-desk/ViewRequestForm';
import CreateServiceDesk from './pages/service-desk/CreateServiceDesk';
import DynamicServiceDeskPage from './pages/service-desk/DynamicServiceDeskPage';
import EmailTemplatesLayout from './pages/service-desk/EmailTemplatesLayout';

import DebugPage from './pages/debug';

// Safety
import HazardousChemicalsPage from './pages/safety/hazardous-chemicals/pages/HazardousChemicalsPage';
import ChemicalDetailPage from './pages/safety/hazardous-chemicals/pages/ChemicalDetailPage';
import IncidentsInjuriesPage from './pages/safety/incidents-and-injuries/pages/IncidentsInjuriesPage';
import IncidentsSettingsPage from './pages/safety/incidents-and-injuries/pages/IncidentsSettingsPage';
import { SafetyWalksDashboardPage } from './pages/safety/safety-walks/pages/SafetyWalksDashboardPage';
import { SafetyWalksRegisterPage } from './pages/safety/safety-walks/pages/SafetyWalksRegisterPage';
import { SafetyWalkDetailPage } from './pages/safety/safety-walks/pages/SafetyWalkDetailPage';
import { SafetyWalkFormPage } from './pages/safety/safety-walks/pages/SafetyWalkFormPage';
import { SafetyObservationsPage } from './pages/safety/safety-walks/pages/SafetyObservationsPage';
import { SafetyWalkObservationsPage } from './pages/safety/safety-walks/pages/SafetyWalkObservationsPage';
import { ObservationDetailPage } from './pages/safety/safety-walks/pages/ObservationDetailPage';
import { CloseOutObservationPage } from './pages/safety/safety-walks/pages/CloseOutObservationPage';
import { EditObservationPage } from './pages/safety/safety-walks/pages/EditObservationPage';
import { VerifyCloseOutPage } from './pages/safety/safety-walks/pages/VerifyCloseOutPage';
import OfferView from './pages/public/OfferView';
import MagicLogin from './pages/MagicLogin';
import MobileHome from './pages/mobile/MobileHome';
import { isMobileHost } from './utils/mobileHost';

export default function App() {
  return (
    <AuthProvider>
      <DataProvider>
        <NotificationProvider>
          <Layout>
            <Routes>
              {/* Auth Routes */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignUpPage />} />
              <Route path="/change-password" element={<ChangePasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />

              {/* Public Routes */}
              <Route path="/offer-view/:id" element={<OfferView />} />
              <Route path="/magic-login" element={<MagicLogin />} />
              <Route path="/account-setup" element={<AccountSetup />} />

              {/* Protected Routes */}
              <Route element={<ProtectedRoute />}>
                {/* m.idarah.io: square-apps grid is the canonical landing */}
                <Route path="/home" element={isMobileHost() ? <MobileHome /> : <Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={isMobileHost() ? <Navigate to="/home" replace /> : <DashboardPage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/hr" element={<HRDashboardPage />} />
                <Route path="/organization" element={<OrganizationPage />} />
                <Route element={<AttendanceRoute />}>
                  <Route path="/attendance" element={<AttendanceDashboard />} />
                  <Route path="/attendance/request-leave" element={<RequestLeave />} />
                  <Route path="/attendance/request-leave/:id" element={<RequestLeave />} />
                  <Route path="/attendance/calendar" element={<LeaveCalendar />} />
                  <Route path="/attendance/history" element={<AttendanceHistory />} />
                  <Route path="/attendance/approvals" element={<ApproveRequests />} />
                  <Route path="/attendance/report-absence" element={<ReportAbsence />} />
                  <Route path="/attendance/admin" element={<LeaveAdmin />} />
                  <Route path="/attendance/leave-digest" element={<LeaveDigest />} />
                  <Route path="/attendance/adjust-balance/:employeeId" element={<AdjustLeaveBalance />} />
                  <Route path="/attendance/settings" element={<AttendanceSettings />} />
                </Route>


                <Route path="/announcements/new" element={<AnnouncementFormPage />} />
                <Route path="/announcements/:id/edit" element={<AnnouncementFormPage />} />
                <Route path="/announcements/:id" element={<AnnouncementPage />} />

                <Route path="/departments" element={<DepartmentsPage />} />
                <Route path="/departments/:id" element={<DepartmentPage />} />

                <Route path="/people" element={<PeoplePage />} />
                <Route path="/people/add" element={<AddPersonPage />} />
                <Route path="/people/edit/:id" element={<EditPersonPage />} />
                <Route path="/people/settings" element={<PeopleSettingsPage />} />
                <Route path="/people/:id" element={<PersonPage />} />
                <Route path="/people/:id/archive" element={<ArchivePersonPage />} />
                <Route path="/people/:personId/qualifications/add" element={<AddQualificationPage />} />
                <Route path="/qualifications/add" element={<AddQualificationPage />} />
                <Route path="/qualifications/recycle-bin" element={<RecycleBinPage />} />
                <Route path="/qualifications/settings" element={<QualificationSettingsPage />} />
                <Route path="/qualifications" element={<QualificationRegisterPage />} />

                {/* Learning (LEARNING.md §7.1). No route-level CASL guards exist in this
                    app — each page does its own ability.can() early return. */}
                <Route path="/learning/courses" element={<CourseLibraryPage />} />
                <Route path="/learning/courses/new" element={<CourseFormPage />} />
                <Route path="/learning/courses/:id/edit" element={<CourseFormPage />} />
                <Route path="/learning/register" element={<LearningRegisterPage />} />
                <Route path="/learning/register/:courseId" element={<AssignmentDetailPage />} />
                <Route path="/learning/categories" element={<CourseCategoriesPage />} />
                <Route path="/learning-admin/_brief" element={<LearningBriefPage />} />
                <Route path="/learning/settings" element={<LearningSettingsPage />} />

                <Route path="/my-learning" element={<MyLearningPage />} />
                <Route path="/my-learning/:courseId" element={<CourseIntroPage />} />
                <Route path="/my-learning/:courseId/player" element={<CoursePlayerPage />} />
                <Route path="/my-performance" element={<MyPerformancePage />} />
                <Route path="/performance-settings" element={<PerformanceSettingsPage />} />
                <Route path="/performance-settings/:id" element={<PerformanceSettingsPage />} />
                <Route path="/people/:personId/qualifications/edit/:qualificationId" element={<EditQualificationPage />} />

                <Route path="/procedure" element={<NewProceduresListPage />} />
                <Route path="/procedure/:id" element={<NewProcedurePage />} />
                <Route path="/procedure/new" element={<ProcedureFormPage />} />
                <Route path="/procedure/:id/edit" element={<ProcedureFormPage />} />

                {/* Procedures (legacy) */}
                <Route path="/procedures" element={<ProceduresPage />} />
                <Route path="/procedures/new" element={<ProcedureFormPage />} />
                <Route path="/procedures/:id/edit" element={<ProcedureFormPage />} />
                <Route path="/procedures/:id" element={<ProcedurePage />} />

                {/* Training routes removed - now using Training Plans */}

                <Route path="/activities" element={<ActivitiesPage />} />
                <Route path="/activities/:id" element={<ActivityPage />} />

                <Route path="/job-roles" element={<JobRolesPage />} />
                <Route path="/job-roles/new" element={<AddJobRolePage />} />
                <Route path="/job-roles/:id" element={<JobRolePage />} />
                <Route path="/job-roles/:id/edit" element={<EditJobRolePage />} />
                <Route path="/job-roles/settings" element={<JobRoleSettings />} />
                <Route path="/job-roles/:id/positions/new" element={<JobPositionFormPage />} />
                <Route path="/job-roles/:id/positions/:positionId/edit" element={<JobPositionFormPage />} />
                <Route path="/job-roles/:id/positions/:positionId/copy" element={<JobPositionFormPage />} />

                <Route path="/training-plans" element={<TrainingPlansPage />} />
                <Route path="/training-plans/:id" element={<TrainingPlansPageDetail />} />
                <Route path="/training-plans/new" element={<TrainingPlanForm />} />
                <Route path="/training-plans/:id/edit" element={<TrainingPlanForm />} />
                <Route path="/training-plans/settings" element={<TrainingPlanSettings />} />

                {/* Recruitment routes */}
                <Route path="/recruitment" element={<RecruitmentDashboard />} />
                <Route path="/recruitment/requisitions/:id" element={<RequisitionDetail />} />
                <Route path="/recruitment/requisitions/:id/add-candidate" element={<AddCandidate />} />
                <Route path="/recruitment/new-requisition" element={<NewRecruitmentRequest />} />
                <Route path="/recruitment/requisitions/:id/edit" element={<EditRecruitmentRequest />} />
                <Route path="/recruitment/candidates/:id" element={<CandidateDetail />} />
                <Route path="/recruitment/candidates/:id/edit" element={<EditCandidate />} />
                <Route path="/recruitment/candidates/:id/offer" element={<CreateOffer />} />
                <Route path="/recruitment/offers/:id" element={<OfferDetail />} />
                <Route path="/recruitment/settings" element={<RecruitmentSettings />} />
                <Route path="/recruitment/settings/offer-templates/new" element={<NewOfferTemplate />} />
                <Route path="/recruitment/settings/offer-templates/:id/edit" element={<EditOfferTemplate />} />
                <Route path="/recruitment/interview-templates" element={<InterviewTemplates />} />
                <Route path="/recruitment/interview-templates/new" element={<CreateInterviewTemplate />} />
                <Route path="/recruitment/interview-templates/:id/edit" element={<CreateInterviewTemplate />} />
                <Route path="/recruitment/values" element={<ValuesManagement />} />

                {/* Onboarding routes */}
                <Route path="/onboarding" element={<OnboardingDashboard />} />
                <Route path="/onboarding/templates" element={<OnboardingTemplates />} />
                <Route path="/onboarding/templates/:id" element={<OnboardingTemplateEdit />} />
                <Route path="/onboarding/settings" element={<OnboardingSettings />} />
                <Route path="/onboarding/commence/:candidateId" element={<CommenceHiring />} />
                <Route path="/onboarding/:id" element={<OnboardingDetail />} />
                <Route path="/onboarding/:id/hr-finance" element={<OnboardingHrFinanceTasks />} />
                <Route path="/my-onboarding" element={<MyOnboardingPortal />} />
                <Route path="/my-onboarding/new-starter-form" element={<NewStarterForm />} />
                <Route path="/my-onboarding/courses/:courseId" element={<CoursePlayerPage onboarding />} />
                <Route path="/my-onboarding/forms/:formId" element={<OnboardingFormPage />} />

                {/* Policy routes */}
                <Route path="/policies" element={<PoliciesPage />} />
                <Route path="/policies/new" element={<PolicyNewPage />} />
                <Route path="/policies/assign" element={<PolicyAssignPage />} />
                <Route path="/policies/new-assign" element={<PolicyNewAssignPage />} />
                <Route path="/policies/:id" element={<PolicyDetailPage />} />
                <Route path="/policy-edit/:id" element={<PolicyEditPage />} />
                <Route path="/my-policies" element={<MyPoliciesPage />} />
                <Route path="/my-policies/:id/view" element={<PolicyViewPage />} />

                {/* Development routes */}
                <Route path="/development" element={<DevelopmentPage />} />
                <Route path="/development/settings" element={<DelegationSettingsPage />} />
                <Route path="/development/:id" element={<DevelopmentPersonPage />} />

                {/* Memo routes */}
                <Route path="/memos/new" element={<MemoNewPage />} />
                <Route path="/memos/assign" element={<MemoAssignPage />} />
                <Route path="/memos/:id" element={<MemoViewPage />} />
                <Route path="/memos/:id/edit" element={<MemoEditPage />} />
                <Route path="/memo-sign/:id" element={<MemoSignPage />} />
                <Route path="/memos/new-assign" element={<MemoNewAssignPage />} />

                <Route path="/lists/customers" element={<CustomersPage />} />
                <Route path="/lists/vendors" element={<VendorsPage />} />
                <Route path="/lists/branches" element={<BranchesPage />} />
                <Route path="/lists/projects" element={<ProjectsPage />} />

                {/* Stock (STOCK.md). Yards and Products are section-wide; the per-yard
                    order routes are added as each order type is built. */}
                {/* Global nodes (STOCK-MENU.md §2) */}
                <Route path="/stock" element={<StockDashboardPage />} />
                <Route path="/stock/products" element={<ProductLibraryPage />} />
                <Route path="/stock/settings/yards" element={<YardsPage />} />
                <Route path="/stock/settings/yards/new" element={<YardFormPage />} />
                <Route path="/stock/settings/yards/:id/edit" element={<YardFormPage />} />
                <Route path="/stock/settings/deliveries" element={<DeliverySettingsPage />} />
                <Route path="/stock/closed-yards" element={<ClosedYardsPage />} />
                <Route path="/stock/transfers" element={<TransferOrdersPage />} />
                <Route path="/stock/transfers/:id" element={<TransferOrderDetailPage />} />

                {/* Yard-scoped nodes */}
                <Route path="/stock/yards/:yardId/returns" element={<ReturnOrdersPage />} />
                <Route path="/stock/yards/:yardId/returns/new" element={<ReturnOrderFormPage />} />
                <Route path="/stock/yards/:yardId/returns/:id" element={<ReturnOrderDetailPage />} />
                <Route path="/stock/yards/:yardId/deliveries" element={<DeliveryOrdersPage />} />
                <Route path="/stock/yards/:yardId/deliveries/new" element={<DeliveryOrderFormPage />} />
                <Route path="/stock/yards/:yardId/deliveries/:id" element={<DeliveryOrderDetailPage />} />
                <Route path="/stock/yards/:yardId/deliveries/:id/pick" element={<PickSheetPage />} />
                <Route path="/stock/deliveries" element={<DeliveryOrdersPage />} />
                <Route path="/stock/deliveries/new" element={<DeliveryOrderFormPage />} />
                <Route path="/stock/deliveries/:id" element={<DeliveryOrderDetailPage />} />
                <Route path="/stock/deliveries/:id/pick" element={<PickSheetPage />} />
                <Route path="/stock/yards/:yardId/imports" element={<ImportOrdersPage />} />
                <Route path="/stock/yards/:yardId/imports/new" element={<ImportOrderFormPage />} />
                <Route path="/stock/yards/:yardId/imports/:id" element={<ImportOrderDetailPage />} />
                <Route path="/stock/imports" element={<ImportOrdersPage />} />
                <Route path="/stock/imports/new" element={<ImportOrderFormPage />} />
                <Route path="/stock/imports/:id" element={<ImportOrderDetailPage />} />

                {/* Procurement → Purchase Orders. Branch-scoped, not yard-scoped: AP raises
                    the PO against a branch and the goods land wherever the delivery goes. */}
                <Route path="/stock/procurement" element={<ProcurementDashboardPage />} />
                <Route path="/stock/procurement/purchase-orders" element={<PurchaseOrdersPage />} />
                <Route path="/stock/procurement/purchase-orders/new" element={<PurchaseOrderFormPage />} />
                <Route path="/stock/procurement/purchase-orders/:id" element={<PurchaseOrderDetailPage />} />
                <Route path="/stock/procurement/approvals" element={<PurchaseOrderApprovalsPage />} />
                <Route path="/stock/procurement/receiving" element={<ReceivingQueuePage />} />
                <Route path="/stock/procurement/receiving/:id" element={<ReceiptCapturePage />} />
                <Route path="/stock/procurement/settings" element={<ProcurementSettingsPage />} />

                {/* Closed yards keep the same sub-tree, read-only (§6) */}
                <Route path="/stock/closed-yards/:yardId/returns" element={<ReturnOrdersPage />} />
                <Route path="/stock/closed-yards/:yardId/returns/:id" element={<ReturnOrderDetailPage />} />
                <Route path="/stock/closed-yards/:yardId/deliveries" element={<DeliveryOrdersPage />} />
                <Route path="/stock/closed-yards/:yardId/deliveries/:id" element={<DeliveryOrderDetailPage />} />
                <Route path="/stock/closed-yards/:yardId/imports" element={<ImportOrdersPage />} />
                <Route path="/stock/closed-yards/:yardId/imports/:id" element={<ImportOrderDetailPage />} />

                {/* Legacy unscoped paths — kept so existing links and the cross-yard view work */}
                <Route path="/stock/yards" element={<YardsPage />} />
                <Route path="/stock/returns" element={<ReturnOrdersPage />} />
                <Route path="/stock/returns/new" element={<ReturnOrderFormPage />} />
                <Route path="/stock/returns/:id" element={<ReturnOrderDetailPage />} />

                <Route path="/inventory" element={<InventoryManagement />} />
                <Route path="/inventory/issuances/new" element={<CreateIssuance />} />
                <Route path="/inventory/issuances/:id/edit" element={<EditIssuance />} />
                <Route path="/business-systems" element={<BusinessSystemsManagement />} />
                <Route path="/business-systems/new" element={<CreateBusinessSystem />} />
                <Route path="/business-systems/:id/edit" element={<EditBusinessSystem />} />
                <Route path="/business-systems/:id" element={<BusinessSystemDetails />} />
                <Route path="/assets" element={<AssetDashboard />} />
                <Route path="/assets" element={<AssetDashboard />} />
                <Route path="/assets/action-items" element={<AssetActionItems />} />
                <Route path="/assets/settings" element={<AssetSettings />} />
                <Route path="/assets/new" element={<CreateAsset />} />
                <Route path="/assets/print" element={<PrintLabels />} />
                <Route path="/assets/assign" element={<AssignAssets />} />
                <Route path="/assets/:id/assignments/:assignmentId" element={<AssignmentDetails />} />
                <Route path="/assets/:id/return" element={<ReturnAsset />} />
                <Route path="/assets/:id/reassign" element={<ReassignAsset />} />
                <Route path="/assets/:id" element={<AssetDetails />} />
                <Route path="/assets/:id/edit" element={<EditAsset />} />
                <Route path="/assets/:id/maintenance/new" element={<ScheduleMaintenance />} />
                <Route path="/assets/:id/maintenance/:maintenanceId" element={<MaintenanceDetails />} />
                <Route path="/assets/:id/inspect" element={<NewInspection />} />
                <Route path="/assets/:id/inspections/:inspectionId" element={<ViewInspection />} />
                <Route path="/assets/electrical-inspections/new" element={<NewElectricalInspectionPage />} />
                <Route path="/assets/electrical-inspections/:id" element={<ElectricalInspectionDetails />} />
                <Route path="/assets/electrical-inspections/:id/edit" element={<EditElectricalInspectionPage />} />
                <Route path="/assets/lifting-inspections/new" element={<NewLiftingInspectionPage />} />
                <Route path="/assets/lifting-inspections/:id" element={<LiftingInspectionDetails />} />
                <Route path="/assets/lifting-inspections/:id/edit" element={<EditLiftingInspectionPage />} />
                <Route path="/assets/:id/repair/new" element={<RecordRepair />} />
                <Route path="/assets/:id/repair/:repairId" element={<RepairDetails />} />
                <Route path="/assets/:id/repair/:repairId/edit" element={<EditRepair />} />
                <Route path="/assets/:id/reminders/new" element={<AddReminderPage />} />
                <Route path="/assets/:id/reminders/:reminderId/edit" element={<EditReminderPage />} />

                {/* Finance routes */}
                <Route path="/finance/direct-debit" element={<DirectDebitRegisterPage />} />
                <Route path="/finance/direct-debit/list" element={<DirectDebitListPage />} />
                <Route path="/finance/direct-debit/new" element={<DirectDebitCreatePage />} />
                <Route path="/finance/direct-debit/:id" element={<DirectDebitDetailsPage />} />
                <Route path="/finance/direct-debit/:id/edit" element={<DirectDebitEditPage />} />
                <Route path="/finance/direct-debit/settings" element={<FinanceSettingsPage />} />

                {/* Service Desk routes */}
                <Route path="/my-requests" element={<MyRequests />} />
                <Route path="/my-requests/new" element={<CreateRequest />} />
                <Route path="/service-desk/view/:id" element={<RequestView />} />
                <Route path="/service-desk/:deskId/requests/new" element={<CreateRequest />} />
                <Route path="/service-desk/admin" element={<AdminDashboard />} />
                <Route path="/service-desk/:deskId" element={<DynamicServiceDeskPage />} />
                <Route path="/service-desk/:deskId/forms/:formId/preview" element={<CreateRequest />} />
                <Route path="/service-desk/settings" element={<ServiceDeskSettings />} />
                <Route path="/service-desk/settings/:id" element={<ServiceDeskSettings />} />
                <Route path="/service-desk/new" element={<CreateServiceDesk />} />
                <Route path="/service-desk/:deskId/forms/new" element={<CreateRequestForm />} />
                <Route path="/service-desk/:deskId/forms/:formId" element={<ViewRequestForm />} />
                <Route path="/service-desk/:deskId/forms/:formId/edit" element={<CreateRequestForm />} />

                {/* Temporary Email Template Previews */}
                {process.env.REACT_APP_DEBUG_EMAIL_SERVICE === 'true' && (
                  <Route path="/service-desk/email-templates" element={<EmailTemplatesLayout />} />
                )}

                <Route path="/safety/hazardous-chemicals" element={<HazardousChemicalsPage />} />
                <Route path="/safety/hazardous-chemicals/:id" element={<ChemicalDetailPage />} />
                <Route path="/safety/incidents" element={<IncidentsInjuriesPage />} />
                <Route path="/safety/incidents/settings" element={<IncidentsSettingsPage />} />
                <Route path="/safety/walks" element={<SafetyWalksDashboardPage />} />
                <Route path="/safety/walks/register" element={<SafetyWalksRegisterPage />} />
                <Route path="/safety/walks/observations" element={<SafetyWalkObservationsPage />} />
                <Route path="/safety/walks/new" element={<SafetyWalkFormPage />} />
                <Route path="/safety/walks/:walkId" element={<SafetyWalkDetailPage />} />
                <Route path="/safety/observations" element={<SafetyObservationsPage />} />
                <Route path="/safety/observations/:obsId/close-out" element={<CloseOutObservationPage />} />
                <Route path="/safety/observations/:obsId/verify-close-out" element={<VerifyCloseOutPage />} />
                <Route path="/safety/observations/:obsId/edit" element={<EditObservationPage />} />
                <Route path="/safety/observations/:obsId" element={<ObservationDetailPage />} />
                <Route path="/safety/walks/:walkId/observations/:obsId" element={<ObservationDetailPage />} />

                <Route path="/help" element={<HelpPage />} />

                <Route path="/debug" element={<DebugPage />} />
              </Route>

              {/* Fallback */}
              <Route path="*" element={<Navigate to={isMobileHost() ? "/home" : "/dashboard"} replace />} />
            </Routes>

            <Toaster position="top-right" richColors closeButton duration={3000} />
          </Layout>
        </NotificationProvider>
      </DataProvider>
    </AuthProvider>
  );
}
